"use client";

import { LoadingArea } from "@ui/loading";
import dynamic from "next/dynamic";
import { FeatureCardsViewProps } from "./feature-cards-view";

const FeatureCardsView = dynamic(() => import("./feature-cards-view"), {
  ssr: false,
  loading: () => <LoadingArea h="100vh" w="full" />,
});

export const FeatureCards = (props: FeatureCardsViewProps) => {
  return <FeatureCardsView {...props} />;
};
